module.exports = __webpack_public_path__ + "static/media/jc_logo.7fe94131.png";